/**
 * default prefix "TOP_BAR"
 **/
export const AT_TOP_BAR_NAME_STATUS_SET = 'TOP_BAR_NAME_STATUS_SET';
export const AT_LAST_USED_FILTERS = 'TOP_BAR_LAST_USED_FILTERS';
export const AT_IS_SHARE_HINT_SHOW_SET = 'TOP_BAR_IS_SHARE_HINT_SHOW_SET';
